module.exports = __webpack_public_path__ + "assets/search_black_24dp.03bb87e7.svg";